var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.6667 10H15.3333C12.3878 10 10 12.3878 10 15.3333V48.6667C10 51.6122 12.3878 54 15.3333 54H48.6667C51.6122 54 54 51.6122 54 48.6667V15.3333C54 12.3878 51.6122 10 48.6667 10Z",
    stroke: "#94535C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 30V43.3333C30.6667 44.0406 30.3857 44.7189 29.8856 45.219C29.3855 45.7191 28.7072 46 28 46H24M46 30H40.6667C39.9594 30 39.2811 30.281 38.781 30.781C38.281 31.2811 38 31.9594 38 32.6667V35.3333C38 36.0406 38.281 36.7189 38.781 37.219C39.2811 37.719 39.9594 38 40.6667 38H43.3333C44.0406 38 44.7189 38.281 45.219 38.781C45.7191 39.2811 46 39.9594 46 40.6667V43.3333C46 44.0406 45.7191 44.7189 45.219 45.219C44.7189 45.7191 44.0406 46 43.3333 46H38",
    stroke: "#94535C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.a9dd5333e5f2b377ca5c8218309d1615.svg";
export { ForwardRef as ReactComponent };